import { useState } from "react";
import { DotLegalAlert, DotLegalDatePicker, DotLegalDialog, DotLegalTextField } from "@dotlegal/dotlegal-ui-components";
import { useTranslation } from "@localization/useTranslation";
import { isNullOrWhitespace } from "@common/stringOperations";

interface AcceptRiskDialogProps {
    inProgress: boolean;
    onClose: () => void;
    onSubmit: (reason: string, reviewBy: Date | null) => void;
}

// Accepting the risk from the mitigation overview supersedes (cancels) the open plan, so the dialog
// leads with that warning. It posts to the treatment endpoint; the plan then shows as Cancelled.
function AcceptRiskDialog({ inProgress, onClose, onSubmit }: AcceptRiskDialogProps) {
    const { translateString, getDateTimePickerLanguage } = useTranslation();
    const [reason, setReason] = useState("");
    const [reviewBy, setReviewBy] = useState<Date | null>(null);

    return (
        <DotLegalDialog
            open
            header={translateString("riskMitigationAcceptDialogTitle")}
            buttonOkText={translateString("riskMitigationActionAcceptRisk")}
            onDialogClose={onClose}
            onOkClick={() => onSubmit(reason, reviewBy)}
            okButtonDisabled={isNullOrWhitespace(reason)}
            inProgress={inProgress}
            size={"sm"}
        >
            <DotLegalAlert severity={"warning"} warningText={translateString("riskMitigationAcceptDialogWarning")} />
            <DotLegalTextField label={translateString("justification")} value={reason} onChange={setReason} multiline rows={3} debounce={false} />
            <DotLegalDatePicker
                label={translateString("riskMitigationAcceptReviewBy")}
                value={reviewBy}
                onChange={setReviewBy}
                language={getDateTimePickerLanguage()}
            />
        </DotLegalDialog>
    );
}

export default AcceptRiskDialog;
